import React from 'react';

const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

const GoogleOAuthLogin = (props = {}) => {
    const {
        clientId,
        redirectUri,
        onAuthStart,
        onAuthCancel,
        onSuccess,
        onError,
    } = props;

    const generateOAuthUrl = () => {
        const params = new URLSearchParams({
            client_id: clientId,
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: 'email profile openid',
            prompt: 'consent',
        });

        return `${GOOGLE_AUTH_URL}?${params.toString()}`;
    };

    const handleOAuthAttempt = () => {
        onAuthStart();

        const width = 500;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const oauthUrl = generateOAuthUrl();
        const popup = window.open(
            oauthUrl,
            'Google Sign-In',
            `width=${width},height=${height},left=${left},top=${top}`
        );

        let popupCheck = setInterval(() => {
            try {
                if (!popup || popup.closed) {
                    clearInterval(popupCheck);
                    onAuthCancel();
                }
            } catch (e) {
                return;
            }
        }, 500);

        window.addEventListener('message', (event) => {
            if (event.origin !== window.location.origin) return;
            if (event.data && event.data.type === 'oauth-result') {
                const oauthData = event.data;
                const { code, state } = oauthData;
                if (!code) {
                    onError(new Error('auth code not retrieved'));
                    return;
                }
                clearInterval(popupCheck);
                onSuccess({ code, state });
            }
        });
    };

    return <div onClick={handleOAuthAttempt}>{props.children}</div>;
};

export default GoogleOAuthLogin;
